(ns ui.device)

(defn ios-browser? []
  (let [ua (.-userAgent js/navigator)]
    (or (.includes ua "iPhone")
        (.includes ua "iPad")
        ;; iPadOS 13+ identifies as "Macintosh" with touch support
        (and (.includes ua "Macintosh")
             (exists? (.-ontouchend js/document))))))
